import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getVegetableType = createAsyncThunk(
  "admin/vegetable-type",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/vegetable-type", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getVegetableTypeById = createAsyncThunk(
  "admin/vegetable-type/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/vegetable-type/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortVegetableType = createAsyncThunk(
  "admin/vegetable-type/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/vegetable-type/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postVegetableType = createAsyncThunk(
  "admin/vegetable-type/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/vegetable-type", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteVegetableType = createAsyncThunk(
  "admin/vegetable-type/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/vegetable-type/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateVegetableType = createAsyncThunk(
  "admin/vegetable-type/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/vegetable-type/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const vegetableTypeSlice = createSlice({
  name: "Vegetable Type Store",
  initialState: initialState,
  reducers: {
    addVegetableType(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortVegetableType(state, action) {
      state.data.docs = action.payload;
    },
    deleteVegetableType(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editVegetableType(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getVegetableType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getVegetableType.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getVegetableType.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getVegetableTypeById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getVegetableTypeById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getVegetableTypeById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortVegetableType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortVegetableType.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortVegetableType.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postVegetableType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postVegetableType.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postVegetableType.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteVegetableType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteVegetableType.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteVegetableType.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateVegetableType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateVegetableType.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateVegetableType.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const vegetableTypeActions = vegetableTypeSlice.actions;

export default vegetableTypeSlice.reducer;
